// extracted by mini-css-extract-plugin
export default {"skillDot":"userPage_skillDot__syU-W"};